import React from 'react';
import i18n from 'i18next';
import Link from 'next/link';
import { ChevronDown } from 'react-feather';

const menuName = (menu) =>
    menu.names?.find((item) => item.langCode === i18n.language)?.name ||
    menu.names?.find((item) => item.langCode === 'mn')?.name ||
    '';

// Толгой цэсний нэг зүйл: жижиг sans үсэг, идэвхтэй үед доогуур зураас.
// Хүүхэдтэй цэс дээр дарахад dropdown нээгдэнэ (Header-ийн onClick), бусад нь шууд холбоос.
const MenuItem = ({ menu, onClick, active = false }) => {
    // Контейнер 1400px тул лого + 8 цэс + icon багтах нягт зайтай
    const base = `relative inline-flex items-center gap-1 px-3 py-2 text-[13px] font-medium whitespace-nowrap transition-colors ${
        active ? 'text-paper' : 'text-paper/75 hover:text-paper'
    }`;
    const underline = active ? (
        <span className="absolute left-3 right-3 -bottom-0.5 h-px bg-paper" />
    ) : null;

    if (menu.children && menu.children.length > 0) {
        return (
            <li onClick={onClick} className={`${base} cursor-pointer`}>
                {menuName(menu)}
                <ChevronDown size={12} className="text-paper/60" />
                {underline}
            </li>
        );
    }

    return (
        <li className={base}>
            <Link
                // url нь заримдаа '/yarn' гэх мэт урд нь '/'-тэй хадгалагдсан байдаг тул
                // давхар '//' үүсгэхгүйн тулд нормчилно ('//yarn' нь Next-д гадаад холбоос мэт
                // тооцогдож бүтэн reload үүсгэдэг байсан).
                href={
                    menu.url
                        ? '/' + menu.url.replace(/^\/+/, '')
                        : '/content/' + menu.id
                }
                // Бүтээгдэхүүний хуудсан дээр байхад ангилал солих нь shallow (хуудас дахин ачаалахгүй).
                shallow={Boolean(
                    menu.url &&
                    menu.url.replace(/^\/+/, '').startsWith('products/'),
                )}
            >
                {menuName(menu)}
            </Link>
            {underline}
        </li>
    );
};

export default MenuItem;
